module.exports = __webpack_public_path__ + "img/Button_Prev.cf907793.png";